import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { Button } from '@jutro/legacy/components';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';

import messages from './OccSearchComponent.messages';
import styles from './OccSearchComponent.module.scss';
import metadata from './OccSearchComponent.metadata.json5';
import { ServiceManager } from '@jutro/legacy/services';



function OccSearchComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated,index, viewModelService, setSubmission } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OccSearchComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const localeService = ServiceManager.getService('locale-service');
    const selectedLanguage = localeService.getStoredLanguage();
    const { LoadSaveService } = useDependencies('LoadSaveService');

    const [occupationCodeSearchVisible, setOccupationCodeSearchVisible] = useState(false);
    const [occuName, updateOccupationName] = useState('');
    const [occNameFren, updateOccupationNameFrench] = useState('');
    const [occID, updateOccupationID] = useState('');
    const [professionalClass, updateProfessionalClass] = useState('');
    const occFiePath = `${pathUpdated}.occFie.value`;


    const onCell = (item, index, { id: property }) => item[property];

    const renderSelectButton = (item, index, { id: property }) => (
            // eslint-disable-next-line react/jsx-no-literals
            <Button type='text'  onClick={(e) => onActionClick(item)}>
                Select
            </Button>
        );

    const loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize: pageSize
        };

        return searchOccupationCode(paginationParams);
    };

    const searchOccupationCode = async(paginationParams) => {
       
        if(!paginationParams) {
            paginationParams = {
                fromPage: 0,
                pageSize: 10
            };
        }

        const occFieClassCodeDTO = {
            occID: occID,
            occuName: occuName,
            occNameFren: occNameFren,
            professionalClass: professionalClass
        };

        const reqParam = {
            occFieClassCodeDTO: occFieClassCodeDTO,
            pageNumber: paginationParams.fromPage,
            pageSize: paginationParams.pageSize
        }
        
        const response = await LoadSaveService.getDwellingOccClassCodes_Ext(reqParam, authHeader);
        
        setOccupationCodeSearchVisible(true);

        if(response != null){
            
            return {
                rows: response.occFieCodes,
                numberOfRows: response.maxNumberOfResults
            };

        } else {
            return {
                rows: [],
                numberOfRows: 0
            };
        }
    };

    const clearSearchTexts = () => {
        updateOccupationName('');
        updateOccupationNameFrench('');
        updateOccupationID('');
        updateProfessionalClass('');
    }

    const cancelSearch = () => {
        setOccupationCodeSearchVisible(false);
    }

    const openSearchPanel = () => {
        setOccupationCodeSearchVisible(true);
    } 

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onActionClick = (object, index) => {  
        if (selectedLanguage === "en-CA") {
            _.set(submissionVM, occFiePath, object.occuName);
        } else if (selectedLanguage === "fr-CA") {
            _.set(submissionVM, occFiePath, object.occNameFren);
        }
        setOccupationCodeSearchVisible(false);
        setSubmission(submissionVM)
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        occFieSearchBtn: {
            onClick: () => { searchOccupationCode(); },
            visible: false
        },
        occFieAdapters: {
            visible: occupationCodeSearchVisible,
            key: occID,
            onFetchData: loadData
        },
        occFieSearchContainer: {
            visible: occupationCodeSearchVisible
        },
        occFieAllContainer: {
            visible: occupationCodeSearchVisible
        },
        occFieResetBtn: {
            onClick: () => { clearSearchTexts(); }
        },
        occFieCancelBtn: {
            onClick: () => {cancelSearch(); }
        }, 
        occFieSearchIconBtn: {
            onClick: () => {openSearchPanel(); }
        },
        occupationNameSearchInput : {
            value: occuName,
            visible: selectedLanguage === "en-CA",
            onValueChange: updateOccupationNameFrench,
        },
        occupationNameFrenchSearchInput : {
            value: occNameFren,
            visible: selectedLanguage === "fr-CA",
            onValueChange: updateOccupationNameFrench
        },
        occupationIDSearchInput : {
            value: occID,
            onValueChange: updateOccupationID
        },
        professionalClassSearchInput : {
            value: professionalClass,
            onValueChange: updateProfessionalClass
        },
        searchResultHeader: {
            visible: occupationCodeSearchVisible
        },
        occuName: {
            visible: selectedLanguage === "en-CA"
        },
        occNameFren: {
            visible: selectedLanguage === "fr-CA"
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onActionClick,
            onCell,
            renderSelectButton
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OccSearchComponent.propTypes = wizardProps;
export default withRouter(OccSearchComponent);
